import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Select } from '@agconnections/grow-ui';
import { tillageSystemFields } from '../DataSets';

const TillageSystem = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Select}
      id="tillage"
      name="tillage"
      placeholder="Select tillage system"
      items={tillageSystemFields}
      label="Tillage System"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default TillageSystem;
